import { ModernThemeToggle } from '../ui/ModernThemeToggle';

export default function LoginNavbar() {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <ModernThemeToggle className="scale-90" />
    </div>
  );
}
